<div class="ui container charts-container">
    <div class="left-column">
        <div class="chart-container">
            <div class="chart-header">
                <h3>Total Geofence Profile</h3>
            </div>
            <div class="chart-content">

            </div>
        </div>

        <div class="chart-container">
            <div class="chart-header">
                <h3>Top Geofence Violating Locations</h3>
            </div>
            <div class="chart-content">

            </div>
        </div>

        <div class="chart-container">
            <div class="chart-header">
                <h3>Geofence Alerts</h3>
            </div>
            <div class="chart-content">

            </div>
        </div>
    </div>
    <div class="right-column">
        <div class="chart-container">
            <div class="chart-header">
                <h3>Total Access Attempt Requests</h3>
            </div>
            <div class="chart-content">

            </div>
        </div>
        <div class="chart-container">
            <div class="chart-header">
                <h3>Geofence Activity Over Time</h3>
            </div>
            <div class="chart-content">

            </div>
        </div>
        <div class="chart-container">
            <div class="chart-header">
                <h3>Total Malicious Requests Received Alert</h3>
            </div>
            <div class="chart-content">

            </div>
        </div>

        
    </div>
</div>
